import React from 'react';
import PropTypes from 'prop-types';

import { Container, StyledIcon } from './notifications-menu.css';

import { MenuLabel } from '../main-menu/main-menu.css';

function NotificationsMenu(props) {
	const {
		hasUnread = false,
		isActive = false,
		onMenuItemClick
	} = props;

	const handleMenuItemClick = () => {
		onMenuItemClick();
	};

	return (
		<div data-tooltip="Notifications" data-tooltip-position="right">
			<Container onClick={handleMenuItemClick} isActive={isActive} hasUnread={hasUnread}>
				<StyledIcon use="bell" size={1.25} isActive={isActive} />
				<MenuLabel>Notifications</MenuLabel>
			</Container>
		</div>
	);
}

NotificationsMenu.propTypes = {
	hasUnread: PropTypes.bool,
	isActive: PropTypes.bool,
	onMenuItemClick: PropTypes.func
};

export default NotificationsMenu;
